module.exports = __webpack_public_path__ + "img/Esther.a9f3d886.jpg";